/* eslint-disable no-underscore-dangle */
/* eslint-disable require-yield */
import { put, call, takeLatest } from "redux-saga/effects";
import { LOGIN, GET_BUILDING, FORGOT_PASSWORD, RESET_PASSWORD } from "../action/constant";
import request from "../utils/request";
import {
  loginError,
  loginSuccess,
  forgotPasswordError,
  forgotPasswordSuccess,
  resetPasswordSuccess,
  resetPasswordError
} from "../action/loginAction";
import {
  getBuildingSuccess,
  getBuildingError
} from "../action/dashboardTableAction";

function* loginSaga(action) {
  const url = `Login/adminLogin`;
  try {
    const response = yield call(request, url, {
      method: "GET",
      headers: {
        Authorization: `Basic ${action.data.auth}`
      }
    });
    yield put(loginSuccess(response.data));
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("adminData", JSON.stringify(response.data.user));
    // Prefer react-router history navigation when available to avoid full reloads
    if (action && action.data && action.data.history && typeof action.data.history.replace === "function") {
      action.data.history.replace("/select");
    } else {
      // fallback to full navigation if history is not provided
      window.location.href = "/select";
    }
  } catch (err) {
    yield put(loginError(err.response.data));
  }
}
function* getBuildingSaga(action) {
  const adminRaw = localStorage.getItem("adminData");
  const admin = adminRaw ? JSON.parse(adminRaw) : {};
  const email = admin.email || "";
  // Without an email the list can't be fetched. Report it instead of returning
  // silently, otherwise the select screen waits on a request that never runs.
  if (!email) {
    yield put(getBuildingError({
      message: "Your account has no email to look up buildings with."
    }));
    return;
  }
  const token = localStorage.getItem("token");
  const url = `Building/list?email=${email}`;
  try {
    const response = yield call(request, url, {
      method: "GET",
      headers: {
        Authorization: `VMS-2.0${token}`
      }
    });
    // A user with no buildings may get no `building` key at all; treat that as
    // an empty list rather than crashing on `.length` below.
    const buildings = Array.isArray(response && response.data && response.data.building)
      ? response.data.building
      : [];
    yield put(getBuildingSuccess(buildings));
    localStorage.setItem("buildingData", JSON.stringify(buildings));
    // determine current path safely (fall back to window.location)
    const currentPath =
      action && action.data && action.data.history && action.data.history.location
        ? action.data.history.location.pathname
        : window.location.pathname;

    if (buildings.length !== 1) {
      // navigate to /select if not already there; avoid full reload to prevent loops
      if (currentPath !== "/select") {
        if (action && action.data && action.data.history && typeof action.data.history.replace === "function") {
          action.data.history.replace("/select");
        } else {
          window.history.replaceState({}, "", "/select");
        }
      }
    } else {
      localStorage.setItem("building", JSON.stringify(buildings[0]));
      // navigate to home if not already there; avoid full reload
      if (currentPath !== "/") {
        if (action && action.data && action.data.history && typeof action.data.history.replace === "function") {
          action.data.history.replace("/");
        } else {
          window.history.replaceState({}, "", "/");
        }
      }
    }
  } catch (err) {
    yield put(getBuildingError(err));
  }
}
function* forgotPasswordSaga(action) {
  const url = `Admin/forgetpass?email=${action.data}`;
  try {
    const response = yield call(request, url, {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    });
    yield put(forgotPasswordSuccess(response.data));
  } catch (err) {
    yield put(forgotPasswordError(err.response.data));
  }
}
function* resetPasswordSaga(action) {
  const { data } = action;
  const url = `Admin/resetpass`;
  try {
    const response = yield call(request, url, {
      method: "PUT",
      headers: {
        Accept: "applicatin/json",
        Authorization: `Bearer ${action.data.token}`
      },
      data: {
        password: action.data.password
      }
    });
    yield data.history && data.history.history && data.history.history.replace("/");
    yield put(resetPasswordSuccess(response.data));
  } catch (err) {
    yield put(resetPasswordError(err.response.data));
  }
}

export default function* loginWatcherSaga() {
  yield takeLatest(LOGIN.PENDING, loginSaga);
  yield takeLatest(GET_BUILDING.PENDING, getBuildingSaga);
  yield takeLatest(FORGOT_PASSWORD.PENDING, forgotPasswordSaga);
  yield takeLatest(RESET_PASSWORD.PENDING, resetPasswordSaga);
}
